import React from 'react';
import { DownloadIcon, FileTextIcon, LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { heroMockup, trustBadges } from '../data/content';
const icons = {
  download: DownloadIcon,
  lock: LockIcon,
  file: FileTextIcon
};
export function Hero() {
  return <section id="top" className="w-full scroll-mt-14 bg-ink px-5 pb-16 pt-6 text-white sm:px-8 sm:pb-20 sm:pt-20" data-id="element-93" data-mp="4n1kyqg06arz">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-center text-center" data-id="element-94" data-mp="127ed7af3pjbv">
        <Reveal data-id="element-95" data-mp="xb5r1d2hkpv7">
          <h1 className="font-display text-3xl font-extrabold leading-[1.08] tracking-tight sm:text-5xl md:text-6xl" data-id="element-96" data-mp="x8jnrpmmowis">
            Plan Your Entire Flag Football Season
            <span className="block text-brand sm:mt-2" data-id="element-97" data-mp="nboo33emcq2x">In Under 5 Minutes.</span>
          </h1>
        </Reveal>

        <Reveal delay={0.06} data-id="element-98" data-mp="3d2tln1u126au">
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-white/70 sm:mt-6 sm:text-lg" data-id="element-99" data-mp="382p6bf4uvhm7">
            600 pages of ready-to-use sessions, playbooks, drills and PE lessons for
            coaches of players aged 5–18. Everything done for you.
          </p>
        </Reveal>

        <Reveal delay={0.12} className="w-full" data-id="element-100" data-mp="39acxmohxzmt0">
          <div className="mx-auto mt-6 w-full max-w-3xl overflow-hidden rounded-card border border-white/10 bg-navy p-3 sm:mt-10 sm:p-8" data-id="element-101" data-mp="399jmlbbyab52">
            <img src={heroMockup.src} alt={heroMockup.alt} className="mx-auto aspect-[16/10] w-full object-contain sm:aspect-square" data-id="element-102" data-mp="3eb90qzugz4xd" />
          </div>
        </Reveal>

        <Reveal delay={0.16} className="w-full" data-id="element-103" data-mp="2qk3k4igpg8m0">
          <div className="mx-auto mt-6 w-full max-w-md sm:mt-10" data-id="element-104" data-mp="2qleq8oxmhsga">
            <CtaButton data-id="element-105" data-mp="2vi54d6pvadz2" />
          </div>

          <ul className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-semibold text-white/75 sm:flex-row sm:flex-wrap sm:gap-x-7" data-id="element-106" data-mp="2vj7rr4nzdya8">
            {trustBadges.map(badge => {
            const Icon = icons[badge.icon as keyof typeof icons];
            return <li key={badge.label} className="flex items-center gap-2" data-id="element-107" data-mp="s3mavvwi5mv7">
                  <Icon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-108" data-mp="naa1gt0e9mn1" />
                  {badge.label}
                </li>;
          })}
          </ul>
        </Reveal>
      </div>
    </section>;
}